import { UserLocationContext } from '@honda-canada/user-location';
import { useContext, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import isSSR from '../../../utils/isSSR';
import useSharedApps from '../../../utils/sitecoreContext/useSharedApps';
import { BUILD_AND_PRICE_URL } from '../../../utils/constants';
import { LOCATION_QUERY_PARAM } from '../utils/constants';
import { getDefaultLocationParamsForProvince } from '../../UserLocationModal/utils';
import { useProvinces } from '../../../utils/sitecoreContext';
const useHandleProvinceDeepLinking = (setShowModal) => {
    const { pathname, search, hash: currentHash } = useLocation();
    const modelSelectionUrl = useSharedApps(BUILD_AND_PRICE_URL);
    const sitecoreProvinces = useProvinces();
    const { setLocation, provinceCode: contextProvinceCode } = useContext(UserLocationContext);
    const decodedQueryString = decodeURIComponent(search);
    const query = useMemo(() => new URLSearchParams(decodedQueryString), [decodedQueryString]);
    const locationFromQuery = query.get(LOCATION_QUERY_PARAM);
    useEffect(() => {
        if (pathname != modelSelectionUrl || !locationFromQuery)
            return;
        const province = sitecoreProvinces === null || sitecoreProvinces === void 0 ? void 0 : sitecoreProvinces.find(_province => (_province === null || _province === void 0 ? void 0 : _province.name) === locationFromQuery);
        if (!(province === null || province === void 0 ? void 0 : province.displayName))
            return;
        const locationData = {
            ...getDefaultLocationParamsForProvince(locationFromQuery),
            addressSelectedByUser: true,
        };
        if (contextProvinceCode && contextProvinceCode !== locationFromQuery) {
            setShowModal(true);
        }
        if (!contextProvinceCode) {
            setLocation(locationData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modelSelectionUrl, pathname, setShowModal, sitecoreProvinces]);
    const handleChangeLocationClick = () => {
        const locationData = {
            ...getDefaultLocationParamsForProvince(locationFromQuery),
            addressSelectedByUser: true,
        };
        setShowModal(false);
        setLocation(locationData);
    };
    const handleKeepMyCurrentLocationClick = () => {
        if (!contextProvinceCode || isSSR())
            return;
        query.set(LOCATION_QUERY_PARAM, contextProvinceCode);
        window.history.replaceState({}, '', `${pathname}?${query.toString()}${currentHash}`);
        setShowModal(false);
    };
    return { handleChangeLocationClick, handleKeepMyCurrentLocationClick };
};
export default useHandleProvinceDeepLinking;
